// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__2VEPW","field":"LoginForm_field__3H8x6","title":"LoginForm_title__1kIMZ"};